module.exports = __webpack_public_path__ + "static/img/img-background-42.0fb08ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/carousel_background/img-background-42.png
// module id = sX74
// module chunks = 36